// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__2PQBR","body_boardAndMenu":"Main_body_boardAndMenu__BRoLS","button_menu":"Main_button_menu__3ViHU"};